export default "__VITE_ASSET__CsmYx3e7__"